import { useEffect, useState, useRef } from "react";
import { toast } from "sonner";
import api, { setStepUpHandler, errMsg } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { ShieldCheck } from "lucide-react";

export default function StepUpDialog() {
  const [open, setOpen] = useState(false);
  const [challenge, setChallenge] = useState(null);
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const resolver = useRef(null);

  useEffect(() => {
    setStepUpHandler(() => new Promise(async (resolve) => {
      resolver.current = resolve;
      try {
        const r = await api.post("/auth/step-up/request");
        setChallenge(r.data); setCode(""); setOpen(true);
        if (r.data.simulation) toast.info(`MODE SIMULASI — kode OTP: ${r.data.debug_code}`, { duration: 20000 });
      } catch (e) { toast.error(errMsg(e, "Gagal mengirim OTP")); resolve(false); }
    }));
    return () => setStepUpHandler(null);
  }, []);

  const close = (ok) => { setOpen(false); resolver.current?.(ok); resolver.current = null; };

  const verify = async () => {
    setBusy(true);
    try {
      await api.post("/auth/step-up/verify", { challenge_id: challenge.challenge_id, code });
      toast.success("Verifikasi berhasil");
      close(true);
    } catch (e) { toast.error(errMsg(e, "OTP salah")); } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && close(false)}>
      <DialogContent className="max-w-sm glass" data-testid="step-up-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-emerald-900"><ShieldCheck className="h-5 w-5 text-emerald-600" /> Verifikasi Aksi Sensitif</DialogTitle>
          <DialogDescription>Kode OTP dikirim ke WA {challenge?.masked_wa}. Masukkan untuk melanjutkan.</DialogDescription>
        </DialogHeader>
        <Input data-testid="step-up-otp-input" inputMode="numeric" maxLength={6} placeholder="6 digit OTP" value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} className="h-12 text-center text-2xl tracking-[0.5em] rounded-xl" />
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={() => close(false)} data-testid="step-up-cancel">Batal</Button>
          <Button data-testid="step-up-verify" disabled={code.length !== 6 || busy} onClick={verify} className="bg-emerald-700 hover:bg-emerald-800">Verifikasi</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
